import styled from "styled-components";

import ActionButtonIcon from "../Button/ActionButtonIcon";
import { X, MagnifyingGlass } from "@phosphor-icons/react";
import { useState } from "react";

interface IInput {
    name: string;
    onSearch: any;
}

export default function FieldSearch({ name, onSearch }: IInput) {
    const [inputValue, setInputValue] = useState('');

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        setInputValue(event.target.value);
        if (value === '') {
            onSearch('')
        }
    };

    const handleSearch = (event?: React.FormEvent) => {
        event?.preventDefault();
        onSearch(inputValue.trim());
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter") {
            event.preventDefault(); // Previne o comportamento padrão do Enter, como pular para o próximo input
            handleSearch();
        }
    };

    /*
    * Limpar Campo
  */
    const handleClear = () => {
        setInputValue('');
        onSearch('');
    }

    return (
        <Container>
            <Input
                value={inputValue}
                placeholder={name}
                onChange={handleInputChange}
                onKeyDown={handleKeyDown} />

            <ContentButton>
                <ButtonClear type="button" onClick={handleClear}>
                    {
                        inputValue &&
                        <X size={20} weight="fill" radius={4} />
                    }
                </ButtonClear>

                <ActionButtonIcon
                    icon={<MagnifyingGlass size={18} />}
                    actionButon={handleSearch} />
            </ContentButton>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 4px;
    border: 1px solid ${(props) => props.theme.colors.gray.gray_600};
    border-radius: 24px;
    padding: 0px 5px;
`;
const Input = styled.input`
    font-size: 16px;
    padding-left: 3px;
    width: 80%;
    border-radius: 4px;
`;

const ContentButton = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
`;

const ButtonClear = styled.button`
    display: flex;
    background-color: transparent;
`;